import { useState } from "react";
import { Form, Radio, Input } from "antd";
import { BillTypeData } from "../../data";
import { owntoast } from "../../utils";
function ChooseBillType(props) {
  const [loading, setLoading] = useState(false);

  const onChangeRegno = (e) => {
    props.setBillType((prev) => {
      if (prev !== e.target.value) props.form.setFieldsValue({ regno: "" });
      return e.target.value;
    });
  };

  const getTaxPayerName = (e) => {
    if ((e && e.length === 10) || e.length === 7) {
      setLoading(true);
      props.request({ url: `/sale/company/${e}` }).then((res) => {
        setLoading(false);
        if (res.success) {
          props.form.setFieldsValue({ taxpayername: res.data.name });
          owntoast(res.message, "success");
        } else owntoast(res.message, "error");
      });
    } else {
      owntoast("РД зөв оруулна уу.", "error");
    }
  };
  let isCompany = 1;
  return (
    <div>
      <div className="mt-3 mb-2">
        <Form.Item name="billType" initialValue={1} noStyle>
          <Radio.Group options={BillTypeData} onChange={onChangeRegno} />
        </Form.Item>
      </div>
      {props.billType === 3 ? (
        <div>
          <div className="bg-labelGrey flex justify-between rounded">
            <span className="p-2">РД:</span>
            <Form.Item
              name="taxpayerregno"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "РД оруулна уу.",
                },
                ({ setFieldsValue }) => ({
                  validator(_, value) {
                    if (value.length === 1) {
                      if (new RegExp(/\d/).test(value)) {
                        isCompany = 3;
                      } else if (new RegExp(/[А-Яа-яӨҮөү]/).test(value)) {
                        isCompany = 1;
                      }
                    }

                    if (
                      (value.length <= 7 && isCompany === 3) ||
                      (value.length <= 10 && isCompany === 1)
                    ) {
                      let regArray =
                        isCompany === 1
                          ? [
                              /[А-Яа-яӨҮөү]/,
                              /[А-Яа-яӨҮөү]/,
                              /\d/,
                              /\d/,
                              /\d/,
                              /\d/,
                              /\d/,
                              /\d/,
                              /\d/,
                              /\d/,
                            ]
                          : [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
                      value.split("").map((char, charIndex) => {
                        if (new RegExp(regArray[charIndex]).test(char)) {
                          setFieldsValue({
                            taxpayerregno: value.toUpperCase(),
                          });
                        } else {
                          setFieldsValue({
                            taxpayerregno: value.slice(0, -1).toUpperCase(),
                          });
                        }
                      });
                    } else {
                      setFieldsValue({
                        taxpayerregno: value.slice(0, -1).toUpperCase(),
                      });
                    }

                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Input.Search
                placeholder="РД"
                enterButton="Шалгах"
                loading={loading}
                disabled={loading}
                className="w-52 font-bold text-right pay-input"
                onSearch={getTaxPayerName}
              />
            </Form.Item>
          </div>
          <div className="bg-labelGrey flex justify-between rounded">
            <span className="p-2">ТТ нэр:</span>
            <Form.Item
              name="taxpayername"
              className="mb-0"
              rules={[
                {
                  required: true,
                  message: "Татвар төлөгчийн нэр оруулна уу.",
                },
              ]}
            >
              <Input
                loading={loading}
                disabled={loading}
                placeholder="Татвар төлөгчийн нэр"
                className="w-52 font-bold text-right pay-input"
              />
            </Form.Item>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default ChooseBillType;
